import { LitElement, html, unsafeCSS } from 'lit';
import type { CSSResultGroup, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import style from './home-page.style.sass?inline';
import { themeStyles } from '../../theme';

@customElement('fb-home-page')
export class HomePage extends LitElement {
  static styles: CSSResultGroup = [...themeStyles, unsafeCSS(style)];

  render(): TemplateResult {
    return html`
      <div class="home">
        <h1>Home</h1>
        <p>Platzhalter-Inhalt des Workspaces.</p>
      </div>
    `;
  }
}
